import React, { useEffect, useState } from 'react';
import L from 'leaflet'; // Импорт библиотеки Leaflet
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet';
import { getCookie } from 'typescript-cookie';
import KyLokal from '../../changeLang/drawLocalesKy';
import RuLokal from '../../changeLang/drawLocalesRu';
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 42.875969,
    longitude:  74.603701,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Чуйская область</h3>
      <p style="margin: 4px 0;">
      <strong>Зерно:</strong> 627 тонн<br />
        <strong>Пшеница:</strong> 161 тонн<br />
        <strong>Ячмень:</strong> 178 штук<br />
        <strong>Кукуруза:</strong> 287 тонн<br />
        <strong>Рис:</strong> - тонн<br />
        <strong>Зернобобовые:</strong> 0.8 тонн<br />
        <strong>Сахарная свекла:</strong> 582 тонн<br />
        <strong>Хлопок-Сырец:</strong> 0.1 тонн<br />
        <strong>Табак:</strong> 0.3 тонн<br />
        <strong>Маслиные культуры:</strong> 5.8 тонн<br />
        <strong>Картофель:</strong> 171.2 тонн<br />
        <strong>Овощи:</strong> 456.2 тонн<br />
        <strong>Бахчи:</strong> 627 тонн<br />
        <strong>Плоды и ягоды:</strong> 20.7 тонн<br />
        <strong>Виноград:</strong> 1.3 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude:40.315997,
    longitude:  73.439965  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ошская область</h3>
      <p style="margin: 4px 0;">
      <strong>Зерно:</strong> 333.4 тонн<br />
        <strong>Пшеница:</strong> 82.2 тонн<br />
        <strong>Ячмень:</strong> 38.3 штук<br />
        <strong>Кукуруза:</strong> 212.8 тонн<br />
        <strong>Рис:</strong> 12.8 тонн<br />
        <strong>Зернобобовые:</strong> - тонн<br />
        <strong>Сахарная свекла:</strong> - тонн<br />
        <strong>Хлопок-Сырец:</strong> 29.3 тонн<br />
        <strong>Табак:</strong> 1 тонн<br />
        <strong>Маслиные культуры:</strong> 2.1 тонн<br />
        <strong>Картофель:</strong> 211.3 тонн<br />
        <strong>Овощи:</strong> 198.2 тонн<br />
        <strong>Бахчи:</strong> 49.4 тонн<br />
        <strong>Плоды и ягоды:</strong> 59.6 тонн<br />
        <strong>Виноград:</strong> 0.7 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.428298, 
    longitude: 75.997628,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Нарынская область</h3>
      <p style="margin: 4px 0;">
        <strong>Зерно:</strong> 47.7 тонн<br />
        <strong>Пшеница:</strong> 12.4 тонн<br />
        <strong>Ячмень:</strong> 35.1 штук<br />
        <strong>Кукуруза:</strong> 0.1 тонн<br />
        <strong>Рис:</strong> - тонн<br />
        <strong>Зернобобовые:</strong> - тонн<br />
        <strong>Сахарная свекла:</strong> - тонн<br />
        <strong>Хлопок-Сырец:</strong> - тонн<br />
        <strong>Табак:</strong> - тонн<br />
        <strong>Маслиные культуры:</strong> - тонн<br />
        <strong>Картофель:</strong> 95.7 тонн<br />
        <strong>Овощи:</strong> 5.8 тонн<br />
        <strong>Бахчи:</strong> 49.4 тонн<br />
        <strong>Плоды и ягоды:</strong> 0.5 тонн<br />
        <strong>Виноград:</strong> - тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 42.491147, 
    longitude: 78.399567,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ысык-Кульская область</h3>
      <p style="margin: 4px 0;">
        <strong>Зерно:</strong> 178.2 тонн<br />
        <strong>Пшеница:</strong> 90.3 тонн<br />
        <strong>Ячмень:</strong> 87.1 штук<br />
        <strong>Кукуруза:</strong> - тонн<br />
        <strong>Рис:</strong> - тонн<br />
        <strong>Зернобобовые:</strong> 0.4 тонн<br />
        <strong>Сахарная свекла:</strong> 0.5 тонн<br />
        <strong>Хлопок-Сырец:</strong> - тонн<br />
        <strong>Табак:</strong> - тонн<br />
        <strong>Маслиные культуры:</strong> - тонн<br />
        <strong>Картофель:</strong> 460.7 тонн<br />
        <strong>Овощи:</strong> 56.3 тонн<br />
        <strong>Бахчи:</strong> - тонн<br />
        <strong>Плоды и ягоды:</strong> 72.8 тонн<br />
        <strong>Виноград:</strong> - тонн<br />
      </p>
      </div>
    `
  }, 
  {
    latitude: 40.060518, 
    longitude: 70.819629,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Баткенская область</h3>
      <p style="margin: 4px 0;">
      <strong>Зерно:</strong> 97.7 тонн<br />
        <strong>Пшеница:</strong> 24.4 тонн<br />
        <strong>Ячмень:</strong> 11.4 штук<br />
        <strong>Кукуруза:</strong> 61.9 тонн<br />
        <strong>Рис:</strong> 13.3 тонн<br />
        <strong>Зернобобовые:</strong> 1.8 тонн<br />
        <strong>Сахарная свекла:</strong> 582 тонн<br />
        <strong>Хлопок-Сырец:</strong> - тонн<br />
        <strong>Табак:</strong> 0.1 тонн<br />
        <strong>Маслиные культуры:</strong> - тонн<br />
        <strong>Картофель:</strong> 37.2 тонн<br />
        <strong>Овощи:</strong> 63.8 тонн<br />
        <strong>Бахчи:</strong> 1.4 тонн<br />
        <strong>Плоды и ягоды:</strong> 60.6 тонн<br />
        <strong>Виноград:</strong> 1.9 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.802703, 
    longitude: 71.958225  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Джалал-Абадская область</h3>
      <p style="margin: 4px 0;">
       <strong>Зерно:</strong> 280.8 тонн<br />
        <strong>Пшеница:</strong> 47 тонн<br />
        <strong>Ячмень:</strong> 24.1 штук<br />
        <strong>Кукуруза:</strong> 209.1 тонн<br />
        <strong>Рис:</strong> 20.6 тонн<br />
        <strong>Зернобобовые:</strong> 0.3 тонн<br />
        <strong>Сахарная свекла:</strong> - тонн<br />
        <strong>Хлопок-Сырец:</strong> 34.1 тонн<br />
        <strong>Табак:</strong> - тонн<br />
        <strong>Маслиные культуры:</strong> 5.5 тонн<br />
        <strong>Картофель:</strong> 127.4 тонн<br />
        <strong>Овощи:</strong> 327.1 тонн<br />
        <strong>Бахчи:</strong> 94.31 тонн<br />
        <strong>Плоды и ягоды:</strong> 72.8 тонн<br />
        <strong>Виноград:</strong> - тонн<br />
      </p>
      </div>
    `
  },  {
    latitude: 42.520755, 
    longitude: 72.250591,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Таласская область</h3>
      <p style="margin: 4px 0;">
       <strong>Зерно:</strong> 52.3 тонн<br />
        <strong>Пшеница:</strong> 22.2 тонн<br />
        <strong>Ячмень:</strong> 6.5 штук<br />
        <strong>Кукуруза:</strong> 23.6 тонн<br />
        <strong>Рис:</strong> - тонн<br />
        <strong>Зернобобовые:</strong> 68.9 тонн<br />
        <strong>Сахарная свекла:</strong> 37.6 тонн<br />
        <strong>Хлопок-Сырец:</strong> - тонн<br />
        <strong>Табак:</strong> - тонн<br />
        <strong>Маслиные культуры:</strong> 0.8 тонн<br />
        <strong>Картофель:</strong> 181.1 тонн<br />
        <strong>Овощи:</strong> 96.5 тонн<br />
        <strong>Бахчи:</strong> 2.4 тонн<br />
        <strong>Плоды и ягоды:</strong> 21 тонн<br />
        <strong>Виноград:</strong> - тонн<br />
      </p>
      </div>
    `
  }
  
  
];

const customMarkerIcon = L.icon({
  iconUrl: '/productplant.svg', 
  iconSize: [35, 55],
  iconAnchor: [12, 41], 
  popupAnchor: [1, -34], 
});

export const ProductionPlantsMap = (props: IContentPart, ) => {
  (L as any).drawLocal = getCookie('i18next') === 'ky' ? KyLokal : RuLokal;



  const [geoData, setGeoData] = useState<any>(null);
  const [bishkekGeoData, setBishkekGeoData] = useState<any>(null);
  const [batkenGeoData, setBatkenGeoData] = useState<any>(null);
  const [chuiGeoData, setChuiGeoData] = useState<any>(null);
  const [issikulGeoData, setIssikulGeoData] = useState<any>(null);
  const [jalalabadGeoData, setJalalabadGeoData] = useState<any>(null);
  const [narinGeoData, setNarinGeoData] = useState<any>(null);
  const [oshGeoData, setOshGeoData] = useState<any>(null);
  const [oshoblGeoData, setOshoblGeoData] = useState<any>(null);
  const [talasGeoData, setTalasGeoData] = useState<any>(null);
  useEffect(() => {
 
    const fetchGeoData = async (file: string, setGeoData: React.Dispatch<React.SetStateAction<any>>, label: string) => {
      try {
        const response = await fetch(`/${file}`);
      
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
      
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        } else {
          console.warn(`Данные geojson отсутствуют или неверный формат в ${label}:`, data);
        }
      } catch (error) {
  
      }
    };

  

    fetchGeoData('polygons/search.json', setGeoData, 'polygons/search.json');
    fetchGeoData('polygons/bishkek.json', setBishkekGeoData, 'polygons/bishkek.json');
    fetchGeoData('polygons/batken.json', setBatkenGeoData, 'polygons/batken.json');
    fetchGeoData('polygons/chui.json', setChuiGeoData, 'polygons/chui.json');
    fetchGeoData('polygons/issikul.json', setIssikulGeoData, 'polygons/issikul.json');
    fetchGeoData('polygons/jalalabad.json', setJalalabadGeoData, 'polygons/jalalabad.json');
    fetchGeoData('polygons/narin.json', setNarinGeoData, 'polygons/narin.json');
    fetchGeoData('polygons/osh.json', setOshGeoData, 'polygons/osh.json');
    fetchGeoData('polygons/oshobl.json', setOshoblGeoData, 'polygons/oshobl.json');
    fetchGeoData('polygons/talas.json', setTalasGeoData, 'polygons/talas.json');

  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={6}
      minZoom={6}
      scrollWheelZoom={true}
      zoomControl={false}
    >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* {geoData && <GeoJSON data={geoData} style={getStyle('blue')} onEachFeature={onEachFeature} />} */}
      
      {markers.map((marker, index) => (
        <Marker key={index} position={[marker.latitude, marker.longitude]} icon={customMarkerIcon}>
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
           {/* {geoData && <GeoJSON data={geoData} style={getStyle('white')} onEachFeature={onEachFeature} />} */}
           {/* {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />} */}
           {bishkekGeoData && <GeoJSON data={bishkekGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {batkenGeoData && <GeoJSON data={batkenGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {chuiGeoData && <GeoJSON data={chuiGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {issikulGeoData && <GeoJSON data={issikulGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {jalalabadGeoData && <GeoJSON data={jalalabadGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {narinGeoData && <GeoJSON data={narinGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {/* {oshGeoData && <GeoJSON data={oshGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />} */}
      {oshoblGeoData && <GeoJSON data={oshoblGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {talasGeoData && <GeoJSON data={talasGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
    </MapContainer>
  );
};
